import Offcanvas from "react-bootstrap/Offcanvas";

const OffcanvasTemplate = ({ open, handleClose, placement, title, body, footer, search, uploadFile }) => {
    return (
        <Offcanvas show={open} onHide={handleClose} placement={placement}>
            {title !== null && (
                <Offcanvas.Header closeButton>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                            <Offcanvas.Title>{title}</Offcanvas.Title>
                            {search}
                        </div>
                        {uploadFile}
                    </div>
                </Offcanvas.Header>
            )}
            <Offcanvas.Body>
                {body}
            </Offcanvas.Body>
            {footer !== null && (
                <div className="offcanvas-footer">
                    {footer}
                </div>
            )}
        </Offcanvas>
    );
};

export default OffcanvasTemplate;
